"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelativePresetTitleTranslated = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var locales_1 = require("../../locales");
exports.RelativePresetTitleTranslated = function (_a) {
    var granularity = _a.granularity;
    var intlDesc = locales_1.messages[granularity] || null;
    if (!intlDesc) {
        return null;
    }
    return react_1.default.createElement(react_intl_1.FormattedMessage, { id: intlDesc.id });
};
//# sourceMappingURL=RelativePresetTitleTranslated.js.map